import * as React from "react";

export interface IConfiguration {
  api_url: string;
  auth_hydra_url: string;
  auth_hydra_client_id: string;
  auth_hydra_client_secret: string;
  auth_pairing_url: string;
  auth_redirect_url: string;
  reward_images_base_url: string;
  white_label_mode: boolean;
  kiosk_splash_image_url: string;
  rewards_flow_enabled_kiosk_splash_image_url: string;
  inactivity_permitted_duration: number;
}

interface IProps {
  className?: string;
  children: React.ReactNode;
}

interface IState {
  loading: boolean;
  config: any;
}

export type IConfig = any;

export const ConfigurationLoaderContext = React.createContext<
  IConfiguration | undefined
>(undefined);

class ConfigurationLoaderGate extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = {
      loading: true,
      config: null
    };
  }

  public render() {
    const { className, children } = this.props;
    const { loading, config } = this.state;
    return (
      <div className={className} title="ConfigLoaderGate">
        {!loading && (
          <ConfigurationLoaderContext.Provider value={config}>
            {children}
          </ConfigurationLoaderContext.Provider>
        )}
      </div>
    );
  }

  public async componentDidMount() {
    const config = await this.loadConfig();

    this.setState({
      loading: false,
      config
    });
  }

  private async loadConfig(): Promise<IConfig> {
    console.log("Loading config.json in ConfigLoaderGate through tunnel");

    let configData: IConfig | void;
    let configFetchedFromNetwork: boolean = false;

    try {
      configData = await loadConfigFromNetwork();
      configFetchedFromNetwork = true;
    } catch (e) {
      console.error("Failed to fetch Config.json. Error: ", e);
      console.log("Attempting to fetch config from cache");
      configData = fetchConfigFromLocalStorage();
      console.log("Successfully retrieved config.json from local storage");
    }

    if (configFetchedFromNetwork) {
      saveConfigToLocalStorage(configData);
    }

    return configData;
  }
}

const loadConfigFromNetwork = async (): Promise<IConfig> => {
  const configResponse = await fetch("/config.json");
  console.log("config.json response received");

  if (configResponse && configResponse.status >= 400) {
    console.error(
      "Server returned error when fetching Config.json. Error code: " +
        configResponse.status +
        " " +
        configResponse.statusText
    );
    throw new Error("Server returned error when fetching Config.json");
  }

  return configResponse.json();
};

const saveConfigToLocalStorage = (config: IConfig) => {
  console.log("Saving config.json to local storage");
  localStorage.setItem("config.json", JSON.stringify(config));
};

const fetchConfigFromLocalStorage = (): IConfig => {
  console.log("Fetching config.json from local storage");

  const configAsString = localStorage.getItem("config.json");

  if (configAsString) {
    console.log("config.json found in local storage. Parsing.");
    return JSON.parse(configAsString);
  }

  console.error("Unable to find config.json in local storage");
  throw Error("Unable to find config.json in local storage");
};

export default ConfigurationLoaderGate;



// WEBPACK FOOTER //
// ./src/components/Gates/ConfigurationLoaderGate.tsx